<template>
	<div class="sideways-content-fold" v-if="activePanel">
		<div class="portlet light bordered" v-if="process !== 'next_actions'">
			<div class="portlet-title">
				<div class="caption">
					Create A Campaign
				</div>
			</div>
			<div class="portlet-body portlet-overflow">
				<form role="form" @submit.prevent="createCampaign($event)" novalidate>
					<div class="alert alert-danger" v-if="errorMessage.length">
					    <button class="close" data-close="alert" @click="clearError()"></button>
                        <span>{{ errorMessage }}</span>
					</div>
					<transition name="fade" mode="out-in">
						<div v-if="process === 'step_1'" key="step_1">
							<div class="form-body invite-user-form">
								<div class="margin-bottom-20">
									<label class="dropdown-label-override">Campaign Type</label>
									<dropdown :forceUpdate="transitionComplete">
										<button slot="button" type="button" class="btn btn-sm btn-outline dropdown-toggle btn-default" data-toggle="dropdown">
											{{ campaignTypes[newCampaign.campaign_type] }}
											<i class="fa fa-angle-down"></i>
										</button>
										<ul slot="dropdown-menu" class="dropdown-menu">
											<li>
												<a @click="setGameType('sw')">Scratch and Win</a>
											</li>
											<li>
												<a @click="setGameType('ig')">Instagage</a>
											</li>
										</ul>
									</dropdown>
								</div>
								<div class="form-group form-md-line-input form-md-floating-label">
		                            <input type="text" class="form-control input-sm" :class="{'edited': newCampaign.name.length}" id="create_campaign_name" v-model.trim="newCampaign.name" maxlength="255">
		                            <label for="create_campaign_name">Campaign Name</label>
		                        </div>
		                        <div class="form-group form-md-line-input form-md-floating-label">
		                            <input type="text" class="form-control input-sm" :class="{'edited': newCampaign.image.length}" id="create_campaign_image" v-model.trim="newCampaign.image" maxlength="255">
		                            <label for="create_campaign_image">Campaign Image</label>
		                        </div>
		                        <div class="form-group form-md-line-input form-md-floating-label no-top-padding">
		                        	<label class="dropdown-label-override">Start On</label>
                    			    <el-date-picker v-model="newCampaign.start_date" :format="'MMM dd, yyyy h:mm A'" type="datetime" :picker-options="datepickerStartOptions" placeholder="Select Start Date*" :editable="false"></el-date-picker>
                    			</div>
                    			<div class="form-group form-md-line-input form-md-floating-label no-top-padding">
		                        	<label class="dropdown-label-override">End On</label>
                    			    <el-date-picker v-model="newCampaign.end_date" :format="'MMM dd, yyyy h:mm A'" type="datetime" :picker-options="datepickerEndOptions" placeholder="Select Start Date*" :editable="false"></el-date-picker>
                    			</div>
                    			<div class="form-md-checkboxes margin-bottom-20" v-if="newCampaign.campaign_type === 'sw'">
                    				<div class="md-checkbox-inline">
                    					<div class="md-checkbox">
                    						<input type="checkbox" id="checkbox-alternate-flow" class="md-check" v-model="newCampaign.alternate_flow" :disabled="process !== 'step_1'">
                    						<label for="checkbox-alternate-flow">
                    							<span></span>
                    							<span class="check"></span>
                    							<span class="box"></span>
                    							Use alternate flow
                    						</label>
                    						<info-popover :content="'By enabling this, the user will be presented with the prize first and then prompted for their information.'"></info-popover>
                    					</div>
                    				</div>
                    			</div>
							</div>
							<div class="form-actions noborder invite-user-actions margin-top-20">
								<button type="button" class="btn btn-default exit-invitation-setup" @click="closePanel()"> Return To UNOgames Dashboard</button>
								<button type="button" class="btn blue" @click="advanceForm($event, 'step_2', 'step_1')" key="create-campaign-continue-one">Continue <i class="fa fa-arrow-circle-right"></i></button>
							</div>
						</div>
						<div v-if="process === 'step_2'" key="step_2">
							<div class="form-body invite-user-form">
								<div class="margin-bottom-20">
									<label class="dropdown-label-override">Phone Number</label>
									<dropdown>
										<button slot="button" type="button" class="btn btn-sm btn-outline dropdown-toggle btn-default" data-toggle="dropdown" :disabled="showKeywordUI">
											{{ (newCampaign.details.twilio_account.id) ? newCampaign.details.twilio_account.phone_number : 'Select a phone number' }}
											<i class="fa fa-angle-down"></i>
										</button>
										<ul slot="dropdown-menu" class="dropdown-menu">
											<template v-for="account in twilioAccounts">
												<li>
													<a @click="setTwilioAccount(account)">{{ account.phone_number }}</a>
												</li>
											</template>
										</ul>
									</dropdown>
								</div>
								<div class="margin-bottom-20 keyword-section">
									<label class="dropdown-label-override">Campaign Keywords</label>
									<a v-if="!showKeywordUI" class="quick-nav-trigger" @click="openKeywordUI()">
										<i class="fa fa-plus"></i>
									</a>
									<div v-if="showKeywordUI" class="portlet box blue-hoki" style="border-top: 1px solid #869ab3">
										<div class="portlet-body clearfix">
											<textarea class="form-control no-border" placeholder="Enter or paste the keywords that the user can text in to enter the contest. Separate your keywords by commas." rows="5" id="keyword-textarea" v-model="keywordInput"></textarea>
											<button class="btn btn-sm blue pull-right" @click="addKeywords()">Add Keywords</button>
										</div>
									</div>
									<div class="table-scrollable">
										<table class="table table-hover table-light">
											<tbody>
												<template v-for="(keyword, index) in newCampaign.details.keywords" v-if="newCampaign.details.keywords.length < 26">
													<tr>
														<td>{{ keyword }}</td>
														<td class="center clickable" @click="removeKeyword(index)">&times;</td>
													</tr>
												</template>
												<tr v-if="newCampaign.details.keywords.length > 25">
													<td class="center">
														<small>You have {{newCampaign.details.keywords.length}} keywords.</small>
													</td>
												</tr>
												<tr v-if="!newCampaign.details.keywords.length">
													<td class="center">
														<small>No campaign keywords added.</small>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
								<div>
				            		<label class="dropdown-label-override">Text2Win Type</label>
									<dropdown>
										<button slot="button" type="button" class="btn btn-sm btn-outline dropdown-toggle btn-default" data-toggle="dropdown" :disabled="showKeywordUI">
											{{ useTypes[newCampaign.details.type] || 'Select a Text2Win type' }}<i class="fa fa-angle-down"></i>
										</button>
										<ul slot="dropdown-menu" class="dropdown-menu">
											<li>
												<a @click="setText2WinType('single_use_case')">Single Use</a>
											</li>
											<li>
												<a @click="setText2WinType('multiple_use_case')">Multiple Use</a>
											</li>
										</ul>
									</dropdown>
								</div>
							</div>
							<div class="form-actions noborder invite-user-actions margin-top-60">
								<button type="button" class="btn btn-default exit-invitation-setup" @click="closePanel()"> Return To UNOgames Dashboard</button>
								<button type="button" class="btn btn-default" @click="reverseForm()" :disabled="showKeywordUI">Back</button>
								<button type="button" class="btn blue" @click="advanceForm($event, 'step_3', 'step_2')" key="create-campaign-continue-two" :disabled="showKeywordUI">Continue <i class="fa fa-arrow-circle-right"></i></button>
							</div>
						</div>
						<div v-if="process === 'step_3'" key="step_3">
							<div class="form-group form-md-line-input form-md-floating-label margin-top-20">
								<div class="form-body invite-user-form">
									<input type="text" class="form-control input-sm" id="form_control_1" v-model="newCampaign.details.response_message" :class="{'edited': newCampaign.details.response_message.length}">
									<label for="form_control_1">SMS Response <small class="font-red-thunderbird" v-if="mergeErrorMessage.length">- {{ mergeErrorMessage }}</small></label>
									<span class="help-block persist">The response the user will receive when they text a valid keyword.</span>
								</div>
								<div>
									<label class="margin-top-40 dropdown-label-override">Insert Merge Fields: <info-popover :content="'Merge Fields will be replaced by the corresponding content when the SMS message is sent.'"></info-popover></label>
									<button class="btn btn-xs blue" type="button" @click="insertMergeField('{EXPIRY_DATE}')">Expiry Date</button>
									<button class="btn btn-xs blue" type="button" @click="insertMergeField('{SHORT_LINK}')">Short Link</button>
								</div>
								<div class="form-group form-md-line-input form-md-floating-label margin-top-20">
									<input type="text" class="form-control input-sm" id="campaign_redeem_message" v-model="newCampaign.details.redeem_message" :class="{'edited': newCampaign.details.redeem_message.length}">
									<label for="campaign_redeem_message">Redeemed Response</label>
									<span class="help-block persist">The response the user will receive if they have exceeded the entry limit.</span>
								</div>
								<div class="form-group form-md-line-input form-md-floating-label margin-top-40">
									<input type="text" class="form-control input-sm" id="campaign_expired_response" v-model="newCampaign.details.expiry_message" :class="{'edited': newCampaign.details.expiry_message.length}">
									<label for="campaign_expired_response">Campaign Expired Response</label>
									<span class="help-block persist">The response the user will receive if the campaign has expired.</span>
								</div>
								<div class="form-group form-md-line-input form-md-floating-label margin-top-40">
									<input type="text" class="form-control input-sm" id="campaign_max_response" v-model="newCampaign.details.exceeded_message" :class="{'edited': newCampaign.details.exceeded_message.length}">
									<label for="campaign_max_response">Max Exceeded Response</label>
									<span class="help-block persist">The response the user will receive if the maximum redemption limits have been exceeded.</span>
								</div>
								<div class="form-group form-md-line-input form-md-floating-label margin-top-40" v-if="newCampaign.campaign_type !== 'ig'">
									<input type="number" class="form-control input-sm" id="campaign_max_redemptions" v-model="newCampaign.details.max_redemptions" :class="{'edited': newCampaign.details.max_redemptions !== null}">
									<label for="campaign_max_redemptions">Max Entries for Campaign <small class="font-grey-cascade">(Use ‘0’ if unlimited)</small></label>
									<span class="help-block persist">The maximum number of entries for the entire campaign.</span>
								</div>
								<div class="form-group form-md-line-input form-md-floating-label margin-top-40" v-if="newCampaign.campaign_type !== 'ig'">
									<input type="number" class="form-control input-sm" id="campaign_max_per_day" v-model="newCampaign.details.max_redemptions_per_day" :class="{'edited': newCampaign.details.max_redemptions_per_day !== null}">
									<label for="campaign_max_per_day">Max Entries Per Day <small class="font-grey-cascade">(Use ‘0’ if unlimited)</small></label>
									<span class="help-block persist">The maximum number of entries allowed for a campaign in a single day for ALL users.</span>
								</div>
								<div class="form-group form-md-line-input form-md-floating-label margin-top-40" v-if="newCampaign.campaign_type !== 'ig'">
									<input type="number" class="form-control input-sm" id="campaign_max_per_day_per_user" v-model="newCampaign.details.max_redemptions_per_day_per_user" :class="{'edited': newCampaign.details.max_redemptions_per_day_per_user !== null}">
									<label for="campaign_max_per_day_per_user">Max Entries Per Day/Per User <small class="font-grey-cascade">(Use ‘0’ if unlimited)</small></label>
									<span class="help-block persist">The maximum number of entries allowed for a campaign in a single day for a SINGLE user.</span>
								</div>
							</div>
							<div class="form-body invite-user-form">
								<div class="form-actions noborder invite-user-actions margin-top-60">
									<button type="button" class="btn btn-default exit-invitation-setup" @click="closePanel()"> Return To UNOgames Dashboard</button>
									<button type="button" class="btn btn-default" @click="reverseForm()">Back</button>
									<button type="submit" class="btn blue" key="create-campaign-confirm">Submit</button>
								</div>
							</div>
						</div>
					</transition>
					<step-counter :steps="steps" :process="process"></step-counter>
				</form>
			</div>
		</div>
		<next-actions v-else :actionsList="createCampaignNextActions" @runFunction="runFunction"></next-actions>
	</div>
</template>
<script>
import $ from 'jquery'
import { findIndex } from 'lodash'
import GlobalFunctions from '../../../global'
import Dropdown from '../../modules/Dropdown'
import InfoPopover from '../../modules/InfoPopover'
import NextActions from '../../modules/NextActions'
import StepCounter from '../../modules/StepCounter'
import UNOgames from '../../../controllers/UNOgames'
import { mapGetters } from 'vuex'

/**
 * Create Campaign module is a page for creating new campaigns in a location.
 * @class CreateCampaign
 * @extends UNOgames
 * @since 0.0.9
 */

export default {
	name: 'create-campaign',
	data () {
		return {
			process: 'step_1',
			activePanel: false,
			errorMessage: '',
			mergeErrorMessage: '',
			campaignId: 0,
			newCampaign: {
				campaign_type: 'none',
				name: '',
				image: '',
				start_date: new Date(),
				end_date: new Date(),
				alternate_flow: false,
				details: {
					type: '',
					twilio_account: {},
					response_message: '',
					redeem_message: '',
					expiry_message: '',
					exceeded_message: '',
					max_redemptions: 0,
					max_redemptions_per_day: 0,
					max_redemptions_per_day_per_user: 0,
					keywords: []
				}
			},
			steps: [{key: 'step_1', name: 'Create Campaign'}, {key: 'step_2', name: 'Keywords'}, {key: 'step_3', name: 'SMS Details'}],
			campaignTypes: {
				none: 'Select a Campaign Type',
				sw: 'Scratch and Win',
				ig: 'Instagage'
			},
			useTypes: {
				'single_use_case': 'Single Use',
				'multiple_use_case': 'Multiple Use'
			},
			datepickerStartOptions: {
				disabledDate: (time) => {
					return time.getTime() < Date.now() - 1000 * 60 * 60 * 24
				}
			},
			datepickerEndOptions: {
				disabledDate: (time) => {
					return time.getTime() < Date.now() - 1000 * 60 * 60 * 24
				}
			},
			twilioAccounts: [],
			showKeywordUI: false,
			keywordInput: '',
			createCampaignNextActions: [{title: 'Design Contest Layout', icon_class: 'fa fa-paint-brush', main_action: true, description: 'Design the look of the contest page that your users will be sent to in order to enter the contest.', click_event: 'createDesign'}, {title: 'Create Prize', icon_class: 'fa fa-gift', description: 'Set up the details of the prize for your contest.', click_event: 'createPrize'}, {title: 'Return to Campaign Dashboard', icon_class: 'fa fa-arrow-circle-left', click_event: 'closePanel'}],
			transitionComplete: true
		}
	},
	/**
	 * Run on created to determine if this should be the active panel or not.
	 * @function
	 * @return {undefined}
	 * @memberof CreateCampaign
	 * @version 0.0.9
	 */
	created () {
		if (this.$route.name === 'UNOgames - Create Campaign') {
			this.activePanel = true
			this.transitionComplete = false
			setTimeout(() => {
				this.transitionComplete = true
			}, 600)
		}
	},
	computed: mapGetters([
		'activeLocationId'
	]),
	methods: {
		/**
		 * To clear the current error.
		 * @function
		 * @returns {undefined}
		 * @memberof CreateCampaign
		 * @version 0.0.9
		 */
		clearError () {
			this.errorMessage = ''
		},
		/**
		 * To set the campaign type.
		 * @function
		 * @param {string} type - The campaign type that is being set.
		 * @returns {undefined}
		 * @memberof CreateCampaign
		 * @version 0.0.9
		 */
		setGameType (type) {
			this.newCampaign.campaign_type = type
		},
		/**
		 * To set the desired Twilio account.
		 * @function
		 * @param {string} account - The Twilio account that is being set.
		 * @returns {undefined}
		 * @memberof CreateCampaign
		 * @version 0.0.9
		 */
		setTwilioAccount (account) {
			this.newCampaign.details.twilio_account = account
		},
		/**
		 * To set the desired Text2Win type.
		 * @function
		 * @param {string} type - The type that is being set.
		 * @returns {undefined}
		 * @memberof CreateCampaign
		 * @version 0.0.9
		 */
		setText2WinType (type) {
			this.newCampaign.details.type = type
		},
		/**
		 * To open the keyword UI.
		 * @function
		 * @returns {undefined}
		 * @memberof CreateCampaign
		 * @version 0.0.9
		 */
		openKeywordUI () {
			this.showKeywordUI = true

			setTimeout(() => {
				$('#keyword-textarea').focus()
			}, 0)
		},
		/**
		 * To add the keywords to the campaign and hide the keyword entry UI.
		 * @function
		 * @returns {undefined}
		 * @memberof CreateCampaign
		 * @version 0.0.9
		 */
		addKeywords () {
			let keywords = this.keywordInput.split(',')
			this.showKeywordUI = false

			if (keywords.length) {
				keywords.forEach(keyword => {
					if (this.newCampaign.details.keywords.indexOf(keyword.trim()) === -1 && keyword.trim().length) {
						this.newCampaign.details.keywords.push(keyword.trim())
					}
				})
			}

			this.keywordInput = ''
		},
		/**
		 * To remove a specific keyword from the list of keywords.
		 * @function
		 * @param {integer} index - The index of the keyword to remove from the keyword list.
		 * @returns {undefined}
		 * @memberof CreateCampaign
		 * @version 0.0.9
		 */
		removeKeyword (index) {
			this.newCampaign.details.keywords.splice(index, 1)
		},
		/**
		 * To insert the merge field at the end of the current response message.
		 * @function
		 * @param {string} field - The field that is being added.
		 * @returns {undefined}
		 * @memberof CreateCampaign
		 * @version 0.0.9
		 */
		insertMergeField (field) {
			if (this.newCampaign.details.response_message.indexOf(field) !== -1) {
				this.mergeErrorMessage = 'Each merge field can only be used once.'
				return
			} else {
				this.mergeErrorMessage = ''
			}

			const length = this.newCampaign.details.response_message.length
			if (length && this.newCampaign.details.response_message[length - 1] !== ' ') {
				this.newCampaign.details.response_message += ` ${field} `
			} else {
				this.newCampaign.details.response_message += `${field} `
			}
		},
		/**
		 * To close the create campaign panel by redirecting to the dashboard
		 * @function
		 * @returns {undefined}
		 * @memberof CreateCampaign
		 * @version 0.0.9
		 */
		closePanel () {
			this.process = 'step_1'
			this.$router.push('/app/uno_games')
		},
		/**
		 * To validate that all information on the current step is accurate before allowing the user to proceed.
		 * @function
		 * @param {string} step - The step to be tested.
		 * @returns {object} A promise that will either return an error message or display the success screen.
		 * @memberof CreateCampaign
		 * @version 0.0.9
		 */
		validateFormData (step) {
			let _this = this

			return new Promise((resolve, reject) => {
				switch (step) {
				case 'step_1':
					if (_this.newCampaign.campaign_type === 'none') {
						reject('You must choose a campaign type')
					}
					if (_this.newCampaign.name.length < 3) {
						reject('Campaign name must be at least 3 characters')
					}
					if (!_this.newCampaign.image.length) {
						reject('Campaign image cannot be blank')
					}
					if (new Date() - _this.newCampaign.start_date > 1200000) {
						// Using 1200000 to give the date breathing room of 20 minutes to complete the form in case user chooses `Now`
						reject('Campaign start date must be past the current date and time')
					}
					if (_this.newCampaign.end_date <= _this.newCampaign.start_date) {
						reject('Campaign end date must be past the start date and time')
					}
					break

				case 'step_2':
					if (!_this.newCampaign.details.twilio_account.id) {
						reject('You must choose a phone number')
					}
					if (!_this.newCampaign.details.keywords.length) {
						reject('Your campaign must have at least 1 keyword')
					}
					if (_this.newCampaign.details.type === '') {
						reject('You must choose a Text2Win type')
					}

					break

				case 'step_3':
					if (_this.newCampaign.details.response_message === '') {
						reject('You must have an SMS Response message')
					}
					if (_this.newCampaign.details.redeem_message === '') {
						reject('You must have a Redeemed Response message')
					}
					if (_this.newCampaign.details.expiry_message === '') {
						reject('You must have a Campaign Expired Response message')
					}
					if (_this.newCampaign.details.exceeded_message === '') {
						reject('You must choose a Max Exceeded Response message')
					}
					if (_this.newCampaign.campaign_type === 'sw' && !_this.newCampaign.details.max_redemptions && _this.newCampaign.details.max_redemptions !== 0) {
						reject('You must set Max Entries for Campaign')
					}
					if (_this.newCampaign.campaign_type === 'sw' && !_this.newCampaign.details.max_redemptions_per_day && _this.newCampaign.details.max_redemptions_per_day !== 0) {
						reject('You must set Max Entries Per Day')
					}
					if (_this.newCampaign.campaign_type === 'sw' && !_this.newCampaign.details.max_redemptions_per_day_per_user && _this.newCampaign.details.max_redemptions_per_day_per_user !== 0) {
						reject('You must set Max Entries Per Day/Per User')
					}
					break

				default:
					resolve()
				}

				resolve()
			})
		},
		/**
		 * To move to the next step of the form.
		 * @function
		 * @param {object} event - The click event that prompted this function.
		 * @param {string} step - The step that we are moving to.
		 * @param {string} currentStep - The current step.
		 * @returns {object} A promise that will either return an error message or display the success screen.
		 * @memberof CreateCampaign
		 * @version 0.0.9
		 */
		advanceForm (event, step, currentStep) {
			let disabledButton = GlobalFunctions.disableButton(event)
			let _this = this

			return this.validateFormData(currentStep).then(response => {
				_this.clearError()
				disabledButton.complete().then(() => {
					_this.process = step

					if (step === 'step_2') {
						_this.getTwilioAccounts()
					}
				})
			}).catch(reason => {
				// If validation fails then display the error message
				_this.errorMessage = reason
				disabledButton.cancel()
			})
		},
		/**
		 * To move the form back to the previous step
		 * @function
		 * @returns {undefined}
		 * @memberof CreateCampaign
		 * @version 0.0.9
		 */
		reverseForm () {
			const index = findIndex(this.steps, ['key', this.process])
			if (index) {
				this.process = this.steps[index - 1].key
			}

			return
		},
		/**
		 * To pull the locations Twilio accounts from the gamification backend.
		 * @function
		 * @returns {object} A promise that will either return an error message or display the success screen.
		 * @memberof CreateCampaign
		 * @version 0.0.9
		 */
		getTwilioAccounts () {
			let _this = this

			return UNOgames.getTwilioAccounts(_this.activeLocationId).then(response => {
				_this.twilioAccounts = response.payload.accounts
			}).catch(_this.$root.errorWrapper(e => {
				if (e.responseJSON) {
					switch (e.responseJSON.declaration) {
					}
				}
			}))
		},
		/**
		 * To send the new campaign to the backend.
		 * @function
		 * @param {object} event - The click event that prompted this function.
		 * @returns {object} A promise that will either return an error message or display the success screen.
		 * @memberof CreateCampaign
		 * @version 0.0.9
		 */
		createCampaign (event) {
			let disabledButton = GlobalFunctions.disableButton(event)
			let _this = this

			return _this.validateFormData('step_3').then(response => {
				_this.clearError()
				if (_this.campaignId) {
					_this.createCampaignDetails(disabledButton)
				} else {
					let localStartDate = `${_this.newCampaign.start_date.getFullYear()}-${_this.newCampaign.start_date.getMonth() + 1}-${_this.newCampaign.start_date.getDate()} ${_this.newCampaign.start_date.getHours()}:${_this.newCampaign.start_date.getMinutes()}:${_this.newCampaign.start_date.getSeconds()}`
					let localEndDate = `${_this.newCampaign.end_date.getFullYear()}-${_this.newCampaign.end_date.getMonth() + 1}-${_this.newCampaign.end_date.getDate()} ${_this.newCampaign.end_date.getHours()}:${_this.newCampaign.end_date.getMinutes()}:${_this.newCampaign.end_date.getSeconds()}`
					_this.newCampaign.start_date = localStartDate
					_this.newCampaign.end_date = localEndDate
					return UNOgames.createCampaign(_this.activeLocationId, _this.newCampaign).then(response => {
						_this.campaignId = response.payload.campaign_id
						_this.createCampaignDetails(disabledButton)
					}).catch(_this.$root.errorWrapper(e => {
						if (e.responseJSON) {
							switch (e.responseJSON.declaration) {
							default:
								// No default
							}
						}
						disabledButton.cancel()
					}))
				}
			}).catch(reason => {
				// If validation fails then display the error message
				if (reason) {
					_this.errorMessage = reason
				}
				disabledButton.cancel()
			})
		},
		/**
		 * To send the details of the new campaign to the backend.
		 * @function
		 * @param {object} disabledButton - The disabledButton object.
		 * @returns {object} A promise that will either return an error message or display the success screen.
		 * @memberof CreateCampaign
		 * @version 0.0.9
		 */
		createCampaignDetails (disabledButton) {
			let _this = this

			return UNOgames.createCampaignDetails(_this.activeLocationId, _this.campaignId, _this.newCampaign.details).then(response => {
				_this.clearForm()
				_this.process = 'next_actions'
				disabledButton.complete()
			}).catch(_this.$root.errorWrapper(e => {
				if (e.responseJSON) {
					switch (e.responseJSON.declaration) {
					case 'campaign_expired':
						_this.$swal({
							title: 'Error',
							html: 'You can\'t edit details of an expired campaign.',
							type: 'warning'
						})
						break

					case 'keyphrase_already_exist':
						let keywords = ''
						if (e.responseJSON.payload.campaigns.length > 1) {
							keywords += 's'
						}
						keywords += ' '

						e.responseJSON.payload.campaigns.forEach((campaign, index) => {
							if (index === e.responseJSON.payload.campaigns.length - 1) {
								if (index !== 0) {
									keywords += `and ${campaign.keyphrase} `
								} else {
									keywords += `${campaign.keyphrase} `
								}
							} else {
								keywords += `${campaign.keyphrase}, `
							}
						})

						if (e.responseJSON.payload.campaigns.length > 1) {
							keywords += 'are'
						} else {
							keywords += 'is'
						}

						_this.errorMessage = 'The keyword' + keywords + ' already in use.'
						_this.reverseForm()

						break

					default:
						// No default
					}
				}
				disabledButton.cancel()
			}))
		},
		/**
		 * To clear the object 'newCampaign'
		 * @function
		 * @returns {undefined}
		 * @memberof CreateCampaign
		 * @version 0.0.9
		 */
		clearForm () {
			this.newCampaign = {
				campaign_type: 'none',
				name: '',
				image: '',
				start_date: new Date(),
				end_date: new Date(),
				alternate_flow: false,
				details: {
					type: '',
					twilio_account: {},
					response_message: '',
					redeem_message: '',
					expiry_message: '',
					exceeded_message: '',
					max_redemptions: 0,
					max_redemptions_per_day: 0,
					max_redemptions_per_day_per_user: 0,
					keywords: []
				}
			}
			this.twilioAccounts = []
			this.showKeywordUI = false
			this.keywordInput = ''
		},
		/**
		 * To run the function passed in.
		 * @function
		 * @param {string} functionName - The function that is to be run
		 * @param {array} params - The list of parameters being passed into the function
		 * @returns {undefined}
		 * @memberof CreateCampaign
		 * @version 0.0.9
		 */
		runFunction (functionName, params) {
			if (!params) {
				this[functionName]()
			} else {
				this[functionName](params[0])
			}
		},
		/**
		 * To route to the create design page.
		 * @function
		 * @returns {undefined}
		 * @memberof CreateCampaign
		 * @version 0.0.9
		 */
		createDesign () {
			this.$router.push('/app/uno_games/edit_contest_layout/' + this.campaignId)
		},
		/**
		 * To route to the create prize page.
		 * @function
		 * @returns {undefined}
		 * @memberof CreateCampaign
		 * @version 0.0.9
		 */
		createPrize () {
			this.$router.push('/app/uno_games/edit_contest_prizes/' + this.campaignId)
		}
	},
	watch: {
		/**
		 * To `watch` the $route in order to determine if this panel should be showing or not
		 * @function
		 * @returns {undefined}
		 * @memberof CreateCampaign
		 * @version 0.0.9
		 */
		'$route' () {
			if (this.$route.name === 'UNOgames - Create Campaign') {
				this.activePanel = true
				this.process = 'step_1'
				this.clearForm()

				this.transitionComplete = false
				setTimeout(() => {
					this.transitionComplete = true
				}, 600)
			} else {
				this.activePanel = false
			}
		}
	},
	components: {
		Dropdown,
		InfoPopover,
		NextActions,
		StepCounter
	}
}
</script>
<style>
.dropdown-label-override {
	display: block;
	font-size: 13px;
	color: #888;
}
.keyword-section {
	position: relative;
}
.keyword-section .quick-nav-trigger {
	background-color: #3598DC;
	width: 40px;
	height: 40px;
	top: -5px;
	color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	text-decoration: none;
}
.keyword-section textarea.form-control.no-border {
	border: none;
	resize: none;
	font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// CreateCampaign.vue?54c590f8